let isDev = false;
let isBeta = false;
let isCbt = false;

let config ={
    dev: {
        apiJavaDomain: "https://java-api-dev.cmbrainbowtv.co.kr",
        apiDomain: "https://devapi.cmbrainbowtv.co.kr",
        devOpsDomain: "https://videothumbnail-dev.cmbrainbowtv.co.kr",
        searchElaUrl: "",
        smsDomain: "https://devapi.cmbrainbowtv.co.kr",
        bucketOption: {
            BucketName: "rainbowtv-dev",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbowtv-dev-source71e471f1-y8asegg3fl9w",
            BucketRegion: "ap-northeast-2",
        },
        imageDomain: "https://imagedev.cmbrainbowtv.co.kr",
        videoDomain: "https://voddev.cmbrainbowtv.co.kr",
        payPhp: 'pay.php',
        subscriptBillPhp: 'order/inis/payment/bill/dev',
        billPhp: 'order/inis/payment/dev',
        webDomain: "https://dev.cmbrainbowtv.co.kr",
        statisticsDomain: 'https://wapi-dev.cmbrainbowtv.co.kr',
        statisticsJavaDomain: 'https://stats-dev.cmbrainbowtv.co.kr',

        naverPayOption:{
            partnerId:'np_jmgpe693697',
            clientId:'Z3J8W0YBkm5JN3AR17dS',
            clientSecretKey:'wMSSQON_d2',
            chainId:'Y0U1djdVRlFQNU1',
            mode:'development'
        },

        //TODO 실테스트키 테스트용
        // naverPayOption:{
        //     partnerId:'np_jmgpe693697',
        //     clientId:'KS12mur3lnHwqbNMTJwK',
        //     clientSecretKey:'KGF2rXT1xn',
        //     chainId:'VHkyWmJIZ0U1VFR',
        //     mode:'production'
        // },
        kakaoOption:{
            cid:'TCSUBSCRIP',
            secertKey:"DEV73B5D7ED9F2A191197D531D9104587594A723"
        }
    },
    beta: {
        // 비디오는 개발 서버 바라보고, ela는 실서버 바라봄
        apiJavaDomain: "https://java-api-beta.cmbrainbowtv.co.kr",
        apiDomain: "https://betaapi.cmbrainbowtv.co.kr",
        smsDomain: "https://betaapi.cmbrainbowtv.co.kr",
        bucketOption: {
            BucketName: "rainbowtv-beta",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbow-tv-beta-source71e471f1-vct3ob92jj3w",
            BucketRegion: "ap-northeast-2",
        },
        payPhp: 'pay.php',
        subscriptBillPhp: 'order/inis/payment/bill/beta',
        billPhp: 'inis/payment/beta',
        imageDomain: "https://imagebeta.cmbrainbowtv.co.kr",
        videoDomain: "https://vodbeta.cmbrainbowtv.co.kr",
        webDomain: "https://beta.cmbrainbowtv.co.kr",

        statisticsDomain: 'https://wapi-dev.cmbrainbowtv.co.kr',
        statisticsJavaDomain: 'https://stats-dev.cmbrainbowtv.co.kr',
        naverPayOption:{
            partnerId:'np_jmgpe693697',
            clientId:'Z3J8W0YBkm5JN3AR17dS',
            clientSecretKey:'wMSSQON_d2',
            chainId:'Y0U1djdVRlFQNU1',
            mode:'development'
        },
        kakaoOption:{
            cid:'TCSUBSCRIP',
            secertKey:"DEV73B5D7ED9F2A191197D531D9104587594A723"
        }
    },
    prod: {
        apiJavaDomain: "https://java-api.cmbrainbowtv.co.kr",
        apiDomain: "https://apiv2.cmbrainbowtv.co.kr",
        smsDomain: "https://alarmv2.cmbrainbowtv.co.kr",
        devOpsDomain: "https://videothumbnail.cmbrainbowtv.co.kr",
        searchElaUrl: "",
        bucketOption: {
            BucketName: "rainbowtv",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbow-tv-prod-source71e471f1-ew1vnpziuig1",
            BucketRegion: "ap-northeast-2",
        },
        imageDomain: "https://image.cmbrainbowtv.co.kr",
        videoDomain: "https://vod.cmbrainbowtv.co.kr",
        payPhp: 'payprod.php',
        subscriptBillPhp: 'order/inis/payment/bill/prod',
        billPhp: 'order/inis/payment/prod',
        webDomain: "https://cmbrainbowtv.co.kr",
        statisticsDomain: 'https://wapi.cmbrainbowtv.co.kr',
        statisticsJavaDomain: 'https://stats.cmbrainbowtv.co.kr',
        naverPayOption:{
            partnerId:'np_jmgpe693697',
            clientId:'KS12mur3lnHwqbNMTJwK',
            clientSecretKey:'KGF2rXT1xn',
            chainId:'VHkyWmJIZ0U1VFR',
            mode:'production'
        },

        kakaoOption:{
            cid:'',
            secertKey:"PRD7A2749FCA7DDB66F77457EC29726EAB2F7A47"
        }
    },
    cbt: {
        apiJavaDomain: "https://java-api-cbt.cmbrainbowtv.co.kr",
        apiDomain: "https://cbtapi.cmbrainbowtv.co.kr",
        smsDomain: "https://alarmv2.cmbrainbowtv.co.kr",
        devOpsDomain: "https://videothumbnail-cbt.cmbrainbowtv.co.kr",
        searchElaUrl: "",
        bucketOption: {
            BucketName: "rainbowtv-cbt",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbowtv-cbt-source71e471f1-tolfhenbdaw0",
            BucketRegion: "ap-northeast-2",
        },
        imageDomain: "https://imagecbt.cmbrainbowtv.co.kr",
        videoDomain: "https://vod.cmbrainbowtv.co.kr",
        payPhp: 'pay.php',
        subscriptBillPhp: 'order/inis/payment/bill/cbt',
        billPhp: 'order/inis/payment/cbt',
        webDomain: "https://cbt.cmbrainbowtv.co.kr",
        statisticsDomain: 'https://wapi-beta.cmbrainbowtv.co.kr',
        statisticsJavaDomain: 'https://stats-cbt.cmbrainbowtv.co.kr',

        naverPayOption:{
            partnerId:'np_jmgpe693697',
            clientId:'Z3J8W0YBkm5JN3AR17dS',
            clientSecretKey:'wMSSQON_d2',
            chainId:'Y0U1djdVRlFQNU1',
            mode:'development'
        },
        kakaoOption:{
            cid:'TCSUBSCRIP',
            secertKey:"DEV73B5D7ED9F2A191197D531D9104587594A723"
        }
    },
};

function getConfig(key = "apiDomain") {
    if (isCbt) {
        return config.cbt[key];
    } else if (isBeta) {
        return config.beta[key];
    }
    return isDev ? config.dev[key] : config.prod[key];
}

function setConfig(key, value) {
    if (isDev) {
        config.dev[key] = value;
    } else {
        config.prod[key] = value;
    }
}

let apiDomain = getConfig("apiDomain");

let apiJavaURL = `${getConfig("apiJavaDomain")}/api/`;
let apiJavaDomain = `${getConfig("apiJavaDomain")}`;
let devOpsURL = `${getConfig("devOpsDomain")}/`;
let smsDomain = getConfig("smsDomain");
let apiURL = `${getConfig("apiDomain")}/api/`;
let smsURL = `${getConfig("smsDomain")}/api/`;
let bucketOption = getConfig("bucketOption");
let videoBucketOption = getConfig("videoBucketOption");
let imageDomain = getConfig("imageDomain");
let payPhp = getConfig('payPhp');

let subscriptBillPhp = getConfig('subscriptBillPhp');
let billPhp = getConfig('billPhp');
let webDomain = getConfig('webDomain');
let localStorageKey = 'com.dgmonglab.rainbow-vue-webmobile'


let statisticsDomain = `${getConfig('statisticsDomain')}`;
let statisticsURL = `${getConfig("statisticsDomain")}/api/statistics/`;
let statisticsJavaDomain = `${getConfig('statisticsJavaDomain')}`;
let statisticsJavaURL = `${getConfig("statisticsJavaDomain")}/api/`;

let naverPayOption = getConfig("naverPayOption");
let kakaoOption = getConfig("kakaoOption");

let videoEncodeApi = getConfig("videoEncodeApi");

function setterApiDomain(domain) {
    setConfig("apiDomain", domain);
    apiJavaDomain = getConfig("apiJavaDomain");
    apiJavaURL = `${getConfig("apiJavaDomain")}/api/`;
    apiDomain = getConfig("apiDomain");
    apiURL = `${getConfig("apiDomain")}/api/`;
    devOpsURL = `${getConfig("devOpsDomain")}/`;
    smsURL = `${getConfig("smsDomain")}/api/`;
    statisticsURL = `${getConfig("statisticsDomain")}/api/statistics/`;
    let devDomain = config.dev.apiDomain;
    let prodDomain = config.prod.apiDomain;
    if (devDomain == domain) {
        isDev = true;
    } else if (prodDomain == domain) {
        isDev = false;
    }
    bucketOption = getConfig("bucketOption");
    imageDomain = getConfig("imageDomain");
    webDomain = getConfig('webDomain');
    naverPayOption = getConfig("naverPayOption");
    kakaoOption = getConfig("kakaoOption");
}

export {
    setterApiDomain,
    apiJavaDomain,
    apiJavaURL,
    apiURL,
    smsURL,
    apiDomain,
    devOpsURL,
    smsDomain,
    imageDomain,
    bucketOption,
    videoBucketOption,
    isDev,
    localStorageKey,
    payPhp,
    subscriptBillPhp,
    billPhp,
    webDomain,
    isBeta,
    statisticsDomain,
    statisticsURL,
    naverPayOption,
    kakaoOption,
    isCbt,
    videoEncodeApi,
    statisticsJavaDomain,
    statisticsJavaURL,
};

